import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { api, get, errMsg } from "@/lib/api";

const ROWS = [["opened", "A candidate opens their link", "First time only, for each assessment, work sample or interview."],
  ["started", "A candidate starts", "When they save their first answer."], ["completed", "A candidate finishes", "When they submit."]];

export function NotificationPrefsDialog({ open, onOpenChange }) {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["notif-prefs"], queryFn: () => get("/me/notification-prefs"), enabled: open });
  const set = async (k, v) => {
    const next = { ...data, [k]: v };
    qc.setQueryData(["notif-prefs"], next);
    try { await api.put("/me/notification-prefs", next); toast.success("Notification preferences saved"); } catch (e) { toast.error(errMsg(e)); qc.invalidateQueries({ queryKey: ["notif-prefs"] }); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="notif-prefs-dialog">
        <DialogHeader><DialogTitle>Notification preferences</DialogTitle><DialogDescription>Choose which candidate link alerts you get in the app.</DialogDescription></DialogHeader>
        <div className="divide-y divide-line">
          {ROWS.map(([k, label, hint]) => (
            <label key={k} className="flex items-center justify-between gap-4 py-3">
              <span><span className="block text-sm font-medium text-ink">{label}</span><span className="block text-xs text-ink-secondary">{hint}</span></span>
              <Switch checked={data ? data[k] : true} disabled={!data} onCheckedChange={(v) => set(k, v)} aria-label={label} data-testid={`notif-pref-${k}`} />
            </label>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
